import { Component, ChangeDetectorRef, Input, ComponentFactoryResolver, AfterViewInit, Output, EventEmitter } from '@angular/core';
import { Events, ToastController, AlertController, ModalController } from 'ionic-angular';
import { DriveServiceProvider } from '../../providers/drive-service/drive-service';
import { ConfigApiServiceProvider } from '../../providers/config-api-service/config-api-service';
import { ConfigureServiceProvider } from '../../providers/configure-service/configure-service';
import { SchedulerMailTimePopupComponent } from '../../components/scheduler-mail-time-popup/scheduler-mail-time-popup';
import { MailCampaignComponent } from '../../components/form/mail-campaign/mail-campaign';
import { StoreWrapProvider } from '../../providers/store-wrap/store-wrap';
import { EncrDecrServiceProvider } from '../../providers/encr-decr-service/encr-decr-service';
import { DatePipe } from '@angular/common';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
declare var jQuery;
@Component({
  selector: 'rule-engine',
  templateUrl: 'rule-engine.html'
})
export class RuleEngineComponent implements AfterViewInit {
  @Input() templatefields: any = [];
  @Input() objCurrentFolderProperties: any;
  @Input() allRules: any;
  @Input() fieldProperties: any;
  @Output() clearRulePageComponent: EventEmitter<any> = new EventEmitter<any>();
  fieldSelectOpt: any = [];
  removeConditionIcon: any = false;
  editSummaryArray: any = [];
  ruleID: any = "";
  User_Schedule_ID: any = "";
  objRunScheduler: any = {};
  objActionSentMail: any = {};
  ruleRunSchedule: any = {};
  ruleNameChange: boolean = false;
  fieldIndex: any = 0;
  filterConditionIdx: any = 0;
  filterdateIdx: any = 0;
  ruleDescription: any;
  removeActionIcon: boolean = false;
  schedulerTime: any;
  angularPickerhidden: boolean = false;
  myForm: FormGroup;
  ruleStatus: any;
  @Input() set rulestatusProperties(v: any) {
    if (v) {
      this.ruleStatus = v;
    }
  }
  @Input() set rule_id(v: any) {
    if (v) {
      this.ruleID = v;
    }
  }
  @Input() abcd: any
  @Input() set edit_summary_data(v: any) {
    this.editSummaryArray = v;


    if (this.editSummaryArray.length > 0) {
      this.arrTemplates = [];
      Object.keys(this.storeWrp.storeTemplates).forEach(element => {
        this.arrTemplates.push(this.storeWrp.storeTemplates[element]);
      });
      this.fieldEditSummary(v)
    } else {
      this.ruleID = "";
      this.rule_name = "";
      this.editrulecondition = [];
      this.editruleaction = [];
      this.editStage = [];
      this.fieldProps = [];
      this.StageID = "";
    }
  };
  fieldEditSummary(e) {
    this.editSummaryArray = e;
    this.editrulename = this.editSummaryArray[0]['ruleEdit'];
    if (this.ruleStatus == 'clone') {
      this.rule_name = this.editrulename['RuleName'];
    } else {
      this.rule_name = this.editrulename['RuleName'];
    }
    this.editrulecondition = this.editSummaryArray[0]['ruleCondition'] || {};
    this.editStage = this.editSummaryArray[0]['ruleStage'] || {};
    if (this.editStage.length > 0) {
      this.StageID = this.editStage[0]['StageID']
      this.WorkflowID = this.editStage[0]['WorkflowID']
    }

    this.ruleRunSchedule = this.editSummaryArray[0]['ruleRunSchedule'][0] || {};
    if (this.ruleRunSchedule.length > 0) {
      this.User_Schedule_ID = this.ruleRunSchedule[0]['User_Schedule_ID'];
    }
    if (this.ruleRunSchedule.Event == "Hour") {
      this.ruleRunSchedule.Run_Rule = "Run Every at " + this.ruleRunSchedule.Range + ' ' + this.ruleRunSchedule.Event + '.';
    } else if (this.ruleRunSchedule.Event == "Day") {
      this.ruleRunSchedule.Run_Rule = "Run Every " + this.ruleRunSchedule.Event + " at " + this.ruleRunSchedule.Range + " on Time " + this.ruleRunSchedule.Time + '.';
    } else if (this.ruleRunSchedule.Event == "Month") {
      this.ruleRunSchedule.Run_Rule = "Run Every  " + this.ruleRunSchedule.Event + " at " + this.ruleRunSchedule.Range + " on " + this.ruleRunSchedule.Schedule + 'th ' + this.ruleRunSchedule.Time + '.';
    } else if (this.ruleRunSchedule.Event == "Onetime") {
      this.ruleRunSchedule.Run_Rule = "Run at " + this.datePipe.transform(this.ruleRunSchedule.Date, 'yyyy-MM-dd') + " " + this.ruleRunSchedule.Time + '.';
    }

    if (this.templatefields.fields) {
      this.fields = this.templatefields.fields;
    }
    if (this.editrulecondition) {
      this.editConditionRule();
    }
    this.editruleaction = this.editSummaryArray[0]['ruleAction'];
    if (this.editruleaction) {
      this.editActionRule();
    }
  }
  ruleCondition: any = [];
  ruleAction: any = [];
  fieldProps: any = [];
  rule_name: any = '';
  rule_condition: any = '';
  previousId: any = '';
  ruleActionField: any = [];
  dropdownSettings = {};
  actionPlaceholder: any = '';
  fields: any = [];
  selectField: any = [];
  outputFields: any = [];
  inputJson: any = [{
    "input1": "",
    "params": { "inputCols": {} }
  }]
  outputJson: any = [{
    "templateID": "",
    "sourceKey": {
    }
  }]
  ruleHeader: any = [];
  postArr: any = [];
  workFlowName: any;
  folderId: any;
  ruleStage: any = [];
  WorkflowID: any = '';
  StageID: any = '';
  private mailModalPopupOpen: boolean = false;
  private schedulerModalPopupOpen: boolean = false;
  editrulename: any;
  ruleName: any;
  editrulecondition: any;
  editruleaction: any;
  outputField: any;
  editStage: any;
  arrTemplates: any = [];
  arrTemplateFields: any = [];
  actionfield: any = [];
  actionActiveFields: any = [];
  screen: any = '';
  setDateIndex: any = [];
  defSettings: any = {
    bigBanner: false,
    timePicker: false,
    format: 'yyyy-MM-dd',
    defaultOpen: false,
  }
  conditionOpt: any = {
    'Decimal': [
      { key: 'equal to', symbol: " == ", label: 'equal to' },
      { key: 'graterthan', symbol: " >= ", label: 'graterthan' },
      { key: 'lessthan', symbol: " <= ", label: 'lessthan' }
    ], 'Text': [
      { key: 'equal to', symbol: " == ", label: 'equal to' },
      { key: 'Not equal to', symbol: " != ", label: 'equal to' },
      { key: 'CONTAINS', symbol: "CONTAINS", label: 'CONTAINS' },
      { key: 'NOT CONTAINS ', symbol: "NOT CONTAINS", label: 'CONTAINS' },
    ],
    'Date': [
      { key: 'equal to', symbol: " == ", label: 'equal to' },
      { key: 'graterthan equal', symbol: " >= ", label: 'graterthan equal' },
      { key: 'graterthan', symbol: " > ", label: 'graterthan' },
      { key: 'lessthan', symbol: " <", label: 'lessthan' },
      { key: 'lessthan equal', symbol: " <= ", label: 'lessthan equal' },
      { key: 'not equal to', symbol: "!=", label: 'not equal to' },
      { key: 'after', symbol: "after", label: 'after' },
      { key: 'before', symbol: "before", label: 'before' },
    ], 'Select': [
      { key: 'equal to', symbol: " == ", label: 'equal to' }
    ]
  };
  operatorOpt: any = [
    { key: 'AND', label: 'AND' },
    { key: 'OR', label: 'OR' },
  ];
  dateOpt: any = [
    { key: 'bom', label: 'Begin of the month' },
    { key: 'eom', label: 'End of the month' },
    { key: 'today', label: 'Today' },
    { key: 'this week', label: 'This Week' },
    { key: 'next week', label: 'Next Week' },
    { key: 'last week', label: 'Last Week' },
    { key: 'this month', label: 'This Month' },
    { key: 'next month', label: 'Next Month' },
    { key: 'last month', label: 'Last Month' },
    { key: 'this quarter', label: 'This Quarter' },
    { key: 'next quarter', label: 'Next Quarter' },
    { key: 'last quarter', label: 'Last Quarter' },
    { key: 'this year', label: 'This Year' },
    { key: 'next year', label: 'Next Year' },
    { key: 'last year', label: 'Last Year' },
  ];
  scheduleOption: any = [
    { key: 'day', label: 'Days' },
    { key: 'month', label: 'Months' },
    { key: 'year', label: 'Years' }
  ];
  actionFieldOpt: any = [
    // { ActionTypeID: '1', ActionName: 'Tag As *' },
    { ActionTypeID: '2', ActionName: 'Send Email' },
    { ActionTypeID: '3', ActionName: 'Store To Folder' },
    { ActionTypeID: '4', ActionName: 'Run Script' },
  ];
  constructor(public storeWrp: StoreWrapProvider, private fb: FormBuilder, private EncrDecrService: EncrDecrServiceProvider, public events: Events, public alertctrl: AlertController, public modalCtrl: ModalController, public driveService: DriveServiceProvider, public toastController: ToastController, public componentFactoryResolver: ComponentFactoryResolver, private cdr: ChangeDetectorRef, public configApiService: ConfigApiServiceProvider, public configureService: ConfigureServiceProvider, public datePipe: DatePipe) {
    if (window.innerWidth > 700) {
      this.screen = 'web';
    } else {
      this.screen = 'mobile';
    }
  }

  ngOnInit() {
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'FieldName',
      textField: 'DisplayName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };
    this.fields = this.templatefields.fields;
    this.folderId = this.templatefields.folderId;
    this.workFlowName = this.templatefields.folderName;


    if (this.ruleID == "") {
      var defalutField = {
        fieldName: "field 1",
        RuleFilterID: "",
        fieldConditionValue: "",
        FieldDataType: "",
        childField1: true,
        childField2: false,
        childField3: false,
        childField4: false,
        filterConditionIdx: 0,
        filterdateIdx: 0,
        childFieldValue: '',
        closeButton: false,
        fields: this.fields,
        conditionValue: '',
        action: 'update',
        condition: this.conditionOpt,
        operatorValue: '',
        operators: this.operatorOpt,
        DateOption: this.dateOpt,
        scheduleOption: this.scheduleOption,
        fieldMeasureValue: ''
      }
      this.fieldProps.push(defalutField);

      let defalutaction = {
        fieldName: "field2",
        fieldValue: "1",
        fields: this.fields,
        sentMail: false,
        childField: true,
        runScriptChild: false,
        childFieldValue: this.driveService.generateString(10),
        actionStatus: false,
        actionValue: "",
        action: 'update',
        actionField: this.actionFieldOpt,
      }
      this.ruleActionField.push(defalutaction);
    }
  }

  //******* GET Filter Condition******** */
  getFilter(e, i) {
    this.fieldProps[i].filterConditionIdx = e.target.selectedIndex;
    if (e.target.selectedIndex > 6) {
      this.filterDateDynamicModel(i);
      this.fieldProps[i].filterdateIdx = e.target.selectedIndex;
      this.fieldProps[i].dateField = false;
    }
  }
  getdateFilter(e, i) {
    this.fieldProps[i].filterdateIdx = e.target.selectedIndex;
    this.fieldProps[i].childFieldValue = e.target.selectedOptions[0].value;
  }

  getScheduleFilter(e, i) {
    this.fieldProps[i].filterdateIdx = e.target.selectedIndex;
  }

  emptyCondition(index) {
    this.fieldProps[index]["fieldConditionValue"] = "";
    this.fieldProps[index]["operatorValue"] = "";
    this.fieldProps[index]["childFieldValue"] = "";
    this.fieldProps[index]["conditionValue"] = "";
    this.fieldProps[index]["filterConditionIdx"] = 0;
    this.fieldProps[index]["FieldDataType"] = "";
  }
  //***** GET CONDITION FIELD*****/
  getCondition(e, i) {
    this.fieldIndex = 0;
    this.fieldProps[i].filterdateIdx = 0;
    this.fieldIndex = e.target.selectedIndex - 1;
    let data = e["target"]["value"];
    if (data == "") {
      this.fieldProps[i]['childField1'] = false;
      this.fieldProps[i]['childField2'] = false;
      this.fieldProps[i]['childField3'] = false;
      this.fieldProps[i]['childField4'] = false;
    } else {
      if (this.fieldProps[i]["fieldConditionValue"][0] != data) {
        this.emptyCondition(i);
      }
      if (this.fieldProps[i].fields.findIndex(elem => elem.FieldName == data) != -1) {
        this.fieldProps[i]["fieldConditionValue"] = data;
        this.fieldProps[i]['FieldDataType'] = this.fieldProps[i].fields.find(elem => elem.FieldName == data)["FieldDataType"];
        if (this.fieldProps[i].fields.find(elem => elem.FieldName == data)["FieldDataType"] == "DATE") {
          this.fieldProps.dateField = true;
          if (this.fieldProps[i]["filterConditionIdx"] <= 4) {
            this.setDateIndex["setDate" + i] = new Date().toString();
          }
          this.fieldProps[i]['childField1'] = false;
          this.fieldProps[i]['childField2'] = true;
          this.fieldProps[i]['childField3'] = false;
          this.fieldProps[i]['childField4'] = false;
        } else if (this.fieldProps[i].fields.find(elem => elem.FieldName == data)["FieldDataType"] == "DECIMAL") {
          this.filterDateDynamicModel(i);
          this.fieldProps[i]['childField1'] = false;
          this.fieldProps[i]['childField2'] = false;
          this.fieldProps[i]['childField3'] = true;
          this.fieldProps[i]['childField4'] = false;
        } else if (this.fieldProps[i].fields.find(elem => elem.FieldName == data)["FieldDataType"] == "SELECT") {
          this.filterDateDynamicModel(i);
          this.fieldLookup(this.fieldProperties.find(elem => elem.FieldName == data));
          this.fieldProps[i]['childField1'] = false;
          this.fieldProps[i]['childField2'] = false;
          this.fieldProps[i]['childField3'] = false;
          this.fieldProps[i]['childField4'] = true;
        } else {
          this.filterDateDynamicModel(i);
          this.fieldProps[i]['childField1'] = true;
          this.fieldProps[i]['childField2'] = false;
          this.fieldProps[i]['childField3'] = false;
          this.fieldProps[i]['childField4'] = false;
        }
      }
    }
  }
  fieldLookup(sysfldProp) {
    if (sysfldProp && sysfldProp.FieldValues != "") {
      let optionValArr = JSON.parse(sysfldProp.FieldValues);
      if (!this.fieldSelectOpt[sysfldProp.FieldName]) {
        var fieldOpt = []
        optionValArr.forEach(optionValue => {
          fieldOpt.push({ key: optionValue[Object.keys(optionValue)[1]], label: optionValue[Object.keys(optionValue)[1]] });
        });
        this.fieldSelectOpt[sysfldProp.FieldName] = { 'options': fieldOpt };
      }
    }
  }

  filterDateDynamicModel(index) {
    delete this.setDateIndex["setDate" + index];
  }

  addCondition() {
    var defalutField = {
      fieldName: "field 1",
      RuleFilterID: "",
      fieldConditionValue: "",
      FieldDataType: "",
      dateField: false,
      childField1: true,
      childField2: false,
      childField3: false,
      childField4: false,
      filterConditionIdx: 0,
      childFieldValue: '',
      closeButton: false,
      fields: this.fields,
      conditionValue: '',
      action: 'update',
      condition: this.conditionOpt,
      DateOption: this.dateOpt,
      operatorValue: '',
      operators: this.operatorOpt,
      scheduleOption: this.scheduleOption,
      fieldMeasureValue: '',
    }
    this.fieldProps.push(defalutField);
    if (this.fieldProps.filter(element => element.action == 'update').length > 1) {
      this.removeConditionIcon = true;
    }
  }

  /*******
   *EDIT CONDITION 
   ******* */
  editConditionRule() {
    this.editrulecondition.forEach((element, i) => {

      this.editCondition(element, i);
    });
  }

  editCondition(elem, i) {
    var fieldValue = elem.FieldValue.slice(1, -1);
    let fielName = elem.FieldName.split('.').splice(1, 1);
    if (this.fields.findIndex(item => item.FieldName == fielName[0]) != -1) {
      this.fieldIndex = this.fields.findIndex(item => item.FieldName == fielName[0]);
    } else {
      this.fieldIndex = 0;
    }
    let selectedFieldIndex = this.fields.findIndex(item => item.FieldName == fielName[0]);
    let filterConditionIdx = selectedFieldIndex != -1 && this.fields[selectedFieldIndex]["FieldDataType"] == "DATE" ? this.conditionOpt["Date"].findIndex(itemElem => itemElem.symbol == elem.Condition) : selectedFieldIndex != -1 && this.fields[selectedFieldIndex]["FieldDataType"] == "DECIMAL" ? this.conditionOpt["Decimal"].findIndex(itemElem => itemElem.symbol == elem.Condition) : selectedFieldIndex != -1 && this.fields[selectedFieldIndex]["FieldDataType"] == "SELECT" ? this.conditionOpt["Select"].findIndex(itemElem => itemElem.symbol == elem.Condition) : this.conditionOpt["Text"].findIndex(itemElem => itemElem.symbol == elem.Condition);
    if (!isNaN(Date.parse(fieldValue))) {
      if (fieldValue.split("-").length >= 2) {
        this.setDateIndex['setDate' + i] = new Date(fieldValue).toString();
        fieldValue = this.dateOpt[3].key;
      }
    }
    if (this.fields[this.fieldIndex]["FieldDataType"] == "SELECT") {
      this.fieldLookup(this.fieldProperties.find(elem => elem.FieldName == fielName[0]));
    }

    var defalutField = {
      fieldName: "field 1",
      dateField: this.fields[selectedFieldIndex]["FieldDataType"] == "DATE" && elem.FieldMeasure == "" ? true : false,
      RuleFilterID: elem.RuleFilterID,
      fieldConditionValue: fielName,
      FieldDataType: this.fields[this.fieldIndex]["FieldDataType"],
      childField1: this.fields[this.fieldIndex]["FieldDataType"] != "DATE" && this.fields[this.fieldIndex]["FieldDataType"] != "DECIMAL" && this.fields[this.fieldIndex]["FieldDataType"] != "SELECT" ? true : false,
      childField2: this.fields[this.fieldIndex]["FieldDataType"] == "DATE" ? true : false,
      childField3: this.fields[this.fieldIndex]["FieldDataType"] == "DECIMAL" ? true : false,
      childField4: this.fields[this.fieldIndex]["FieldDataType"] == "SELECT" ? true : false,
      filterConditionIdx: filterConditionIdx + 1,
      childFieldValue: elem.FieldMeasure == "" ? fieldValue : "",
      closeButton: true,
      fields: this.fields,
      conditionValue: elem.Condition,
      action: 'update',
      condition: this.conditionOpt,
      operatorValue: elem.Operator,
      DateOption: this.dateOpt,
      filterdateIdx: 0,
      operators: this.operatorOpt,
      scheduleOption: this.scheduleOption,
      fieldMeasure: elem.FieldMeasure,
      fieldMeasureValue: JSON.parse(elem.FieldValue),
    }

    this.fieldProps.push(defalutField);
    if (this.fieldProps[0].childFieldValue == this.dateOpt[3].key) {
      this.fieldProps[i].filterdateIdx = 4;
    }
    if (this.fieldProps.filter(element => element.action == 'update').length > 1) {
      this.removeConditionIcon = true;
    }
  }

  removeCondition(e, index) {
    if (index != 0) {
      this.fieldProps[index]['action'] = 'delete';
    } else if (index == 0) {
      if (this.fieldProps.length > 1) {
        this.fieldProps[index]['action'] = 'delete';
      }
    }
    if (this.fieldProps.filter(element => element.action == 'update').length == 1) {
      this.removeConditionIcon = false;
    }
  }

  getaction(e, i) {
    let data = e["target"]["value"];

    if (data == "1") {
      this.ruleActionField[i].childFieldValue = this.driveService.generateString(10)
      this.actionPlaceholder = "Enter Tag Name";
      this.ruleActionField[i]['childField'] = true;
      this.ruleActionField[i]['templateField'] = false;
      this.ruleActionField[i]['actionStatus'] = false;
      this.ruleActionField[i]['sentMail'] = false;
      this.ruleActionField[i]['runScriptChild'] = false;
    }
    if (data == "2") {
      this.ruleActionField[i].childFieldValue = ''
      this.ruleActionField[i].childFieldValue = ''
      this.ruleActionField[i]['childField'] = false;
      this.ruleActionField[i]['templateField'] = false;
      this.ruleActionField[i]['actionStatus'] = false;
      this.ruleActionField[i]['sentMail'] = true;
      this.ruleActionField[i]['runScriptChild'] = false;
    }
    if (data == "4") {
      this.ruleActionField[i].childFieldValue = ''
      this.ruleActionField[i]['childField'] = false;
      this.ruleActionField[i]['templateField'] = false;
      this.ruleActionField[i]['actionStatus'] = false;
      this.ruleActionField[i]['sentMail'] = false;
      this.ruleActionField[i]['runScriptChild'] = true;

    }
  }

  openMailTemplate(e, i) {
    var _data = { "RuleID": this.ruleID };
    var objData = Object.assign({}, this.configApiService.driveApi.PullMailCampaign.params, _data, { "client": this.configureService.getStudio() })
    this.configApiService.pullRequest(objData, this.getSentMailData);
  }

  getSentMailData = ((respdata) => {
    let _data = Object.assign({}, { 'RuleID': this.ruleID }, respdata[0], { "WorkflowID": this.WorkflowID });
    let generateUrl: any = '';
    let ShareID = '';
    let TagName = '';
    if (_data.ShareID) {
      let urlParams = ShareID + '&studio=' + this.configureService.getStudio() + '&userid=' + this.configureService.getLoginUserID();
      let encUrlParams = this.EncrDecrService.encrypt('DRIVESYNC123##', urlParams);
      if (window.location.search) {
        generateUrl = window.location.origin + window.location.pathname + window.location.search + '&ShareID=' + encUrlParams;
      } else {
        generateUrl = window.location.origin + window.location.pathname + '/?ShareID=' + encUrlParams;
      }

      if (this.ruleActionField.find(elem => elem.childFieldValue != '')) {
        TagName = this.ruleActionField.find(elem => elem.childFieldValue != '')['childFieldValue']
      }
    }

    var fieldData = Object.assign({}, this.configApiService.driveApi.MailcampaignFieldProperties.params, { "client": this.configureService.getStudio() })
    this.configApiService.fieldpropertyRequest(fieldData, (fieldPropValue) => {
      var formMailOpt = [];
      if (fieldPropValue.find(elment => elment.FieldDataType == "SELECT")["FieldValues"]) {
        let fromId = fieldPropValue.find(elment => elment.FieldDataType == "SELECT")["FieldValues"].split(',')
        for (var i = 0; i < fromId.length; i++) {
          formMailOpt.push({ 'key': fromId[i], 'value': fromId[i] })
        }
      }
      let modalPopup
      if (Object.keys(this.objActionSentMail).length > 0) {
        if (!this.mailModalPopupOpen) {
          this.mailModalPopupOpen = true;
          modalPopup = this.modalCtrl.create(MailCampaignComponent, { 'data': this.objActionSentMail, 'formMailOpt': formMailOpt, 'link': generateUrl, 'TagName': TagName, 'objCurrentFolderProperties': this.objCurrentFolderProperties }, { cssClass: 'schedulerMailAlert', enableBackdropDismiss: false });
        }
      } else {
        if (!this.mailModalPopupOpen) {
          this.mailModalPopupOpen = true;
          modalPopup = this.modalCtrl.create(MailCampaignComponent, { 'data': _data, 'formMailOpt': formMailOpt, 'link': generateUrl, 'TagName': TagName, 'objCurrentFolderProperties': this.objCurrentFolderProperties }, { cssClass: 'schedulerMailAlert', enableBackdropDismiss: false });
        }
      }
      modalPopup.present();
      modalPopup.onDidDismiss(data => {

        this.mailModalPopupOpen = false;
        if (data && Object.keys(data).length > 0) {
          this.objActionSentMail = data;
        }
      });
    });

  })

  /******
   * ACTION
   * ********* */
  /*******
   * ADD ACTION
   * ****** */
  addAction() {

    let defalutaction = {
      fieldName: "field2",
      fieldValue: "",
      fields: this.fields,
      childField: false,
      sentMail: false,
      runScriptChild: false,
      childFieldValue: "",
      actionStatus: false,
      actionValue: "",
      templateField: false,
      action: 'update',
      actionField: this.actionFieldOpt
    }
    this.ruleActionField.push(defalutaction);
    if (this.ruleActionField.filter(element => element.action == 'update').length > 1) {
      this.removeActionIcon = true;
    }
  }


  /******
 * EDIT ACTION
 * ***** */
  editActionRule() {
    this.editruleaction.forEach((element, i) => {
      this.editAction(element);
    });
  }

  editAction(elem) {
    let multiSelectOpts, template, showtemplate, showtag, actionStatus, showSentButton, showRunScript;
    if (elem.ActionTypeID == "3") {
      template = elem.ActionValue
      showtemplate = true;
      showtag = false;
      actionStatus = true;
      this.getFields(template, "edit")
    } else if (elem.ActionTypeID == "1") {
      showtag = true;
      showtemplate = false;
      actionStatus = false;
    } else if (elem.ActionTypeID == "2") {
      showSentButton = true;
    } else if (elem.ActionTypeID == "4") {
      showRunScript = true;
      showtag = false;
      showtemplate = false;
      actionStatus = false;
    }
    if (this.ruleStatus == "clone") {
      if (elem.ActionTypeID == "1") {
        elem.ActionValue = this.driveService.generateString(10);
      }
    }
    if (elem.ActionConfig) {
      let opts = elem.ActionConfig.split(',');
      this.selectField = opts;
      this.outputFields = this.selectField.toString();
      multiSelectOpts = this.getMultiSelectOptions(opts);
    } else {
      multiSelectOpts = [];
    }
    let defalutaction = {
      fieldName: "field2",
      fieldValue: elem.ActionTypeID,
      fields: this.fields,
      childField: showtag,
      runScriptChild: showRunScript,
      sentMail: showSentButton,
      childFieldValue: elem.ActionValue,
      actionStatus: actionStatus,
      actionValue: multiSelectOpts,
      templateField: showtemplate,
      action: 'update',
      actionField: this.actionFieldOpt,
    }
    this.ruleActionField.push(defalutaction);
    if (this.ruleActionField.filter(element => element.action == 'update').length > 1) {
      this.removeActionIcon = true;
    }
  }

  getMultiSelectOptions(options) {
    let optArr: any = [];
    for (let fieldName of options) {
      for (let field of this.arrTemplateFields) {
        if (fieldName === field.FieldName) {
          optArr.push(field);
        }
      }
    }
    return optArr;
  }

  /********
   * REMOVE ACTION
   * ********** */
  removeAction(e, index) {
    if (index != 0) {
      this.ruleActionField[index]['action'] = 'delete';
    } else if (index == 0) {
      if (this.ruleActionField.length > 1) {
        this.ruleActionField[index]['action'] = 'delete';
      }
    }
    if (this.ruleActionField.filter(element => element.action == 'update').length == 1) {
      this.removeActionIcon = false;
    }
  }

  /*******
   * SAVE RULE
   * ******** */
  postRules() {
    var f_postRule = true;
    //****** Post Condition *****/
    var conditionDes = "When";
    if (this.fieldProps["length"]) {
      for (var i = 0; i < this.fieldProps.length; i++) {
        var element = this.fieldProps[i];
        let fieldValue, fieldCondition, Operator, RuleFilterID, sheduleFilter;
        var field: any = this.fieldProps[i].fieldConditionValue;
        fieldCondition = this.fieldProps[i].conditionValue || '';
        if (this.fieldProps[i].childFieldValue === 'CustomDate') {
          fieldValue = this.datePipe.transform(this.setDateIndex['setDate' + i], 'yyyy-MM-dd');
        } else if (this.fieldProps[i].childFieldValue !== null && this.fieldProps[i].childFieldValue != '' && this.fieldProps[i].childFieldValue !== 'CustomDate' && this.setDateIndex['setDate' + i] == null) {
          fieldValue = this.fieldProps[i].childFieldValue;
        } else if (this.fieldProps[i].childFieldValue == null) {
          fieldValue = '';
        } else if (this.fieldProps[i]['fieldMeasure'] != null && this.fieldProps[i]['fieldMeasure'] != undefined) {
          fieldValue = this.fieldProps[i]['fieldMeasureValue'];
          sheduleFilter = this.fieldProps[i]['fieldMeasure'];
        } else {
          sheduleFilter = '';
          fieldValue = this.fieldProps[i].childFieldValue;
        }
        RuleFilterID = this.fieldProps[i].RuleFilterID || '';
        Operator = this.fieldProps[i].operatorValue || '';
        if (field != '' && fieldValue != '' && fieldCondition != '') {
          if (this.fieldProps.length == 1) {
            let pushCondition =
            {
              "srckey": "RuleID",
              'RuleID': this.ruleID,
              'RuleFilterID': RuleFilterID,
              'FieldName': "input1." + field,
              'FieldType': element.FieldDataType,
              "action": element['action'],
              'Condition': fieldCondition,
              "FieldMeasure": sheduleFilter,
              'FieldValue': '"' + fieldValue + '"',
              'Operator': Operator
            }
            if (this.fieldProps.length - 1 == i) {
              Operator = ""
            }
            if (fieldCondition == 'after' || fieldCondition == 'before' && sheduleFilter != undefined) {
              if (sheduleFilter != undefined) {
                conditionDes += ' ' + field + ' ' + fieldCondition + ' ' + fieldValue + sheduleFilter + ' ' + Operator;
              }
            } else {
              conditionDes += ' ' + field + ' ' + fieldCondition + ' ' + fieldValue + ' ' + Operator;
            }
            var objData = Object.assign({}, this.configApiService.driveApi.pushCondition.params, pushCondition)
            this.ruleCondition.push(objData);
          } else if (this.fieldProps.length > 1) {
            if (Operator == '') {
              f_postRule = false;
              this.ruleHeader = [];
              this.ruleCondition = [];
              this.ruleAction = [];
              this.ruleStage = [];
              const toast = this.toastController.create({
                message: 'Condition Field Empty!',
                duration: this.configApiService.toastDuration,
                position: 'bottom'
              });
              toast.present();
              break;
            } else {
              let pushCondition =
              {
                "srckey": "RuleID",
                'RuleID': this.ruleID,
                'RuleFilterID': RuleFilterID,
                'FieldName': "input1." + field,
                'FieldType': element.FieldDataType,
                "action": element['action'],
                'Condition': fieldCondition,
                'FieldValue': '"' + fieldValue + '"',
                'Operator': Operator,
                "FieldMeasure": sheduleFilter
              }

              if (this.fieldProps.length - 1 == i) {
                Operator = ""
              }
              if (fieldCondition == 'after' || fieldCondition == 'before') {
                if (sheduleFilter != undefined) {
                  conditionDes += ' ' + field + ' ' + fieldCondition + ' ' + fieldValue + sheduleFilter + ' ' + Operator;
                }
              } else {
                conditionDes += ' ' + field + ' ' + fieldCondition + ' ' + fieldValue + ' ' + Operator;
              }
              var objData = Object.assign({}, this.configApiService.driveApi.pushCondition.params, pushCondition)
              this.ruleCondition.push(objData);
            }
          }

        } else if (!this.ruleCondition.length) {
          f_postRule = false;
          this.ruleHeader = [];
          this.ruleCondition = [];
          this.ruleAction = [];
          this.ruleStage = [];
          const toast = this.toastController.create({
            message: 'Condition Field Empty!',
            duration: this.configApiService.toastDuration,
            position: 'bottom'
          });
          toast.present();

        }
        //****** Folder Columns should be stored as Input in table 'EPC_BRE_STAGE' **** */
        this.inputJson[0]['input1'] = this.templatefields.templateId;
        if (element['action'] != 'delete' && field != '') {
          this.inputJson[0]['params']['inputCols'][field] = '';
        }

      }
    }

    //****** Post Action *****/
    if (this.ruleActionField["length"]) {
      var actionDes = ". Tag Result as";
      this.ruleActionField.forEach((element, i) => {
        let actionValue;
        let tag: any = element.fieldValue || "";
        if (element.childFieldValue == null) {
          if (document.getElementById('template' + i) != null) {
            actionValue = element.childFieldValue;
            this.outputJson[0]['templateID'] = actionValue;
          }
        } else {
          if (element.childFieldValue != null) {
            actionValue = element.childFieldValue;
          }
        }
        if (tag != '') {
          let pushAction = {
            "srckey": "RuleID",
            "RuleID": this.ruleID,
            "ActionTypeID": tag,
            "ActionValue": actionValue || "",
            "ActionConfig": "",
            "action": element['action'],
          }
          if (tag == '3') {
            pushAction['ActionConfig'] = this.outputFields;
          }
          if (actionValue != undefined) {
            actionDes += ' ' + actionValue + ' ';
          }
          var objData = Object.assign({}, this.configApiService.driveApi.pushAction.params, pushAction)
          this.ruleAction.push(objData);
        } else if (!this.ruleAction.length) {
          f_postRule = false;
          this.ruleHeader = [];
          this.ruleCondition = [];
          this.ruleAction = [];
          this.ruleStage = [];
          const toast = this.toastController.create({
            message: 'Action Field Empty!',
            duration: this.configApiService.toastDuration,
            position: 'bottom'
          });
          toast.present();
        }
        //******  Output folder columns should be stores as Output in table EPC_BRE_STAGE **** */
        var innerField = {}
        this.selectField.forEach(element => {
          if (element['action'] != 'delete') {
            innerField[element] = "";
          }
        });
        this.outputJson[0]['sourceKey'] = {};
        this.outputJson[0]['sourceKey'][this.templatefields.templateId] = innerField;
      });


    }
    if (this.ruleRunSchedule.Run_Rule != undefined) {
      // if (this.objRunScheduler.Event == 'Hour'){
      this.ruleDescription = conditionDes + actionDes + 'and Send Email ' + this.ruleRunSchedule.Run_Rule;
      // }
      // if (this.objRunScheduler.Event == 'Day' || this.objRunScheduler.Event == 'Month') {
      //   this.ruleDescription = conditionDes + actionDes + 'and Send Email ' + this.ruleRunSchedule.Run_Rule;
      // } else {
      //   this.ruleDescription = conditionDes + actionDes + 'and Send Email ' + this.ruleRunSchedule.Run_Rule + '.'
      // }
    } else {
      this.ruleDescription = conditionDes + actionDes + '.';
    }



    //****** Post Rule Header *****/
    let pushHeader = {
      "RuleID": this.ruleID,
      "WorkflowID": this.WorkflowID,
      "RuleName": this.rule_name,
      "FolderInfo": this.folderId,
      "WorkFlowname": this.workFlowName,
      "RuleDescription": this.ruleDescription
    }
    var objData = Object.assign({}, this.configApiService.driveApi.pushRule.params, pushHeader)
    this.ruleHeader.push(objData);

    //****** Post Rule Stage *****/
    let pushStage = {
      "srckey": "RuleID:WorkflowID",
      "RuleID": this.ruleID,
      "StageID": this.StageID,
      "input": JSON.stringify(this.inputJson),
      "output": JSON.stringify(this.outputJson),
      "StageName": this.workFlowName,
    }
    var objData1 = Object.assign({}, this.configApiService.driveApi.pushStage.params, pushStage)
    this.ruleStage.push(objData1)
    if (this.rule_name != '') {
      if (f_postRule) {
        this.createRuleFolder();
      }
    } else {
      this.ruleHeader = [];
      this.ruleCondition = [];
      this.ruleAction = [];
      this.ruleStage = [];
      const toast = this.toastController.create({
        message: 'Please Enter Rulename',
        duration: this.configApiService.toastDuration,
        position: 'bottom'
      });
      toast.present();
    }
  }

  /*******
   * GENERATE FOLDER TO STORE RULE DATA
   * 
   * ******** */

  createRuleFolder() {
    if (!this.ruleID) {
      if (this.objCurrentFolderProperties.folders.findIndex(folder => folder.name == this.rule_name) == -1) {
        if (this.ruleNameChange == true) {
          this.ruleHeader[0]['RuleName'] = this.rule_name;
          this.ruleNameChange = false;
        }
        this.generateFolderInsert();
      } else {
        this.ruleHeader = [];
        this.ruleCondition = [];
        this.ruleAction = [];
        this.ruleStage = [];
        const toast = this.toastController.create({
          message: 'Rule Name is already exist please change the rule name',
          duration: this.configApiService.toastDuration,
          position: 'bottom'
        });
        toast.present();
        this.ruleNameChange = true;
      }
    } else {
      let folderIdx = this.objCurrentFolderProperties.folders.findIndex(folder => folder.name == this.rule_name);
      let folder_id;
      if (folderIdx != -1) {
        folder_id = this.objCurrentFolderProperties.folders[folderIdx]['folder_id'];
      }
      this.generateFolderInsert(folder_id);
    }
  }


  generateFolderInsert(folder_id = null) {
    let childFolder = this.ruleAction.findIndex(item => item.ActionTypeID == 1 && item.ActionValue != '');

    this.driveService.createFolderRuleRun(this.rule_name, this.ruleAction[childFolder].ActionValue, this.objCurrentFolderProperties, this.objCurrentFolderProperties, folder_id, (respdata) => {
      if (Object.keys(this.objActionSentMail).length > 0) {
        this.postShareFolder(respdata);
      } else {
        this.submitData();
      }

    })

  }

  /*********
   * POST GENERATED FOLDER TO SHARE
   * ********** */
  postShareFolder(respdata) {

    this.objActionSentMail.folderid = respdata.parent_folder_id;
    let shareFolderID = this.objActionSentMail.attachment_template['ShareType'] == 'Folder' ? respdata.folder_id : ''
    let ShareID = this.objActionSentMail.ShareID || "";
    let SharedInfo = { 'sharedFolder': respdata, 'name': respdata.name, 'IsReadOnlyShare': 'NO', 'accessType': this.objActionSentMail.attachment_template['accessType'], 'pullFolderTemplate': { "client": this.configureService.getStudio(), 'userid': this.configureService.getLoginUserID(), 'app_code': this.configApiService.currentDriveApp['app_code'] } };
    this.objActionSentMail['attachment_template'].sharedFolder = SharedInfo.sharedFolder;
    let sharedFolder = Object.assign({}, this.configApiService.driveApi.pushLinkShareUser.params, {
      "ShareID": ShareID,
      "ShareType": this.objActionSentMail.attachment_template['ShareType'],
      "TemplateID": respdata.template[0].id,
      "TemplateName": respdata.template[0].templateName,
      "ReceiverEmail": this.objActionSentMail.To,
      "SharedInfo": { 'sharedFolder': respdata, 'IsReadOnlyShare': 'NO', 'accessType': this.objActionSentMail['attachment_template']['accessType'], 'pullFolderTemplate': { "client": this.configureService.getStudio(), 'userid': this.configureService.getLoginUserID(), 'app_code': this.configApiService.currentDriveApp['app_code'] } }
    });

    sharedFolder["UserFolder"] = this.objActionSentMail.attachment_template['ShareType'] == 'Folder' ? shareFolderID : "";
    sharedFolder['userid'] = this.configureService.getLoginUserID();
    this.driveService.shareInfoFolder(sharedFolder['SharedInfo'].sharedFolder, sharedFolder['SharedInfo'], (_respData) => {
      sharedFolder.ShareID = _respData;
      respdata['folders'] = [];
      this.configApiService.pushRequest(sharedFolder, ((shareIddata) => {
        ShareID = shareIddata["ShareID"];
        this.generateShareLinkURl(ShareID, shareIddata);
      }))
    })
  }

  generateShareLinkURl(ShareID, shareIddata) {
    let generateUrl: any = '';
    this.objActionSentMail.ShareID = ShareID;
    if (this.objActionSentMail.ShareID) {
      let urlParams = ShareID + '&studio=' + this.configureService.getStudio() + '&userid=' + this.configureService.getLoginUserID();
      let encUrlParams = this.EncrDecrService.encrypt('DRIVESYNC123##', urlParams);

      if (window.location.search) {
        generateUrl = window.location.origin + window.location.pathname + window.location.search + '&ShareID=' + encUrlParams;

      } else {
        generateUrl = window.location.origin + window.location.pathname + '/?ShareID=' + encUrlParams;
      }
      generateUrl = generateUrl.toString();
      if (this.objActionSentMail.Body.includes('href=""') || this.objActionSentMail.Body.includes("href=''")) {
        let TagName = this.ruleAction.find(elem => elem.ActionValue != '')['ActionValue'];
        if(this.objActionSentMail.Body.includes('href=""')){
          this.objActionSentMail.Body = this.objActionSentMail.Body.replace('href=""', "href='" + generateUrl + "'");
        }else if(this.objActionSentMail.Body.includes("href=''")){
          this.objActionSentMail.Body = this.objActionSentMail.Body.replace("href=''", "href='" + generateUrl + "'");
        }
        this.objActionSentMail.Body = this.objActionSentMail.Body.replace('"folder_Name_container">', '"folder_Name_container">' + TagName);
      }
      this.objActionSentMail.ShareID = shareIddata["ShareID"];

    }
    this.submitData();
  }

  /********
   * SUBMIT DATA
   * ************* */
  submitData() {
    this.postArr.push(this.ruleHeader[0]);
    if (this.ruleCondition.length > 0) {
      for (let condition of this.ruleCondition) {
        this.postArr.push(condition);
      }
    }
    if (this.ruleAction.length > 0) {
      for (let action of this.ruleAction) {
        this.postArr.push(action);
      }
    }
    this.postArr.push(this.ruleStage[0]);
    if (Object.keys(this.objActionSentMail).length > 0) {
      let _objActionSentMail = Object.assign({}, { "srckey": "RuleID:WorkflowID" }, this.objActionSentMail);
      this.postArr.push(_objActionSentMail);
    }
    if (Object.keys(this.objRunScheduler).length > 0) {
      let _objRunScheduler = Object.assign({}, { "srckey": "RuleID:WorkflowID" }, this.objRunScheduler);
      this.postArr.push(_objRunScheduler);
    }


    if (this.ruleCondition.length != 0) {
      if (this.ruleAction.length != 0) {
        let obj = {
          PushArray: this.postArr
        };
        var objData = Object.assign({}, this.configApiService.driveApi.pushRulesArray.params, obj, { "client": this.configureService.getStudio(), 'userid': this.configureService.getLoginUserID() })
        this.configApiService.pushRequest(objData, this.submitSuccess);
      } else {
        this.ruleHeader = [];
        this.ruleCondition = [];
        this.ruleAction = [];
        this.ruleStage = [];
        const toast = this.toastController.create({
          message: 'Please Enter Action',
          duration: this.configApiService.toastDuration,
          position: 'bottom'
        });
        toast.present();
      }
    } else {
      this.ruleHeader = [];
      this.ruleCondition = [];
      this.ruleAction = [];
      this.ruleStage = [];
      const toast = this.toastController.create({
        message: 'Please Enter Condition',
        duration: this.configApiService.toastDuration,
        position: 'bottom'
      });
      toast.present();
    }
  }

  submitSuccess = ((resData) => {
    this.WorkflowID = resData[Object.keys(resData)[0]]["WorkflowID"]
    this.ruleID = resData[Object.keys(resData)[0]]["RuleID"];
    this.User_Schedule_ID = resData[Object.keys(resData)[0]]["User_Schedule_ID"];
    this.getSummaryData();
  });



  getSummaryData() {
    let pullSummaryData = {
      "WorkflowID": this.WorkflowID
    }
    var objData = Object.assign({}, this.configApiService.driveApi.PullRulesFolder.params, pullSummaryData, { "client": this.configureService.getStudio() })
    this.configApiService.pullRequest(objData, this.submitSummarySuccess)
  }

  submitSummarySuccess = ((resData) => {
    let sendData = { status: "postruleArr", resData: resData }
    this.clearRulePageComponent.emit(sendData);
  })

  discard() {
    let discardRule = true;
    let alert = this.alertctrl.create({
      title: 'Are you sure, want to discard?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel'
        },
        {
          text: 'Ok',
          handler: data => {
            if (this.ruleStatus == 'clone') {
              let sendData = { status: "cloneRuleDiscard", resData: '' }
              this.clearRulePageComponent.emit(sendData)
            } else {
              this.ruleID = "";
              this.rule_name = "";
              this.editrulecondition = [];
              this.editruleaction = [];
              this.editStage = [];
              this.fieldProps = [];
              this.setDateIndex = [];
              this.StageID = "";
              let sendData = { status: "discard", resData: discardRule }
              this.clearRulePageComponent.emit(sendData)
            }
          }
        }
      ]
    });
    alert.present();
  }
  onFieldDeSelect(item) {
    var idx = this.selectField.findIndex(id => id == item.FieldName);
    if (idx) {
      this.selectField.splice(idx, 1);
      this.outputFields = this.selectField.toString();
    }
  }
  onFieldSelect(item) {
    if (this.selectField.length > 0) {
      for (var i = 0; i < this.selectField.length; i++) {
        if (this.selectField[i] !== item && item !== "") {
          this.selectField.push(item.FieldName);
          item = "";
        }
      }
    } else {
      this.selectField.push(item.FieldName);
    }
    this.outputFields = this.selectField.toString();
  }
  onFieldDeSelectAll(items) {
    this.selectField = [];
    this.outputFields = [];
  }
  onFieldSelectAll(items) {
    var result = items.map(function (val) {
      return val.FieldName;
    }).join(',');

    if (items.length > 0) {
      for (var i = 0; i < items.length; i++) {
        if (items[i].FieldName) {
          this.selectField.push(items[i].FieldName);
        }
      }
    }
    this.outputFields = result;
  }


  ngAfterViewInit() {
    this.cdr.detectChanges();

  }

  /*********
   * GET TEMPLATE OF SELECTED FOLDER
   * *********** */
  getTemplates() {
    Object.keys(this.storeWrp.storeTemplates).forEach(element => {
      this.arrTemplates.push(this.storeWrp.storeTemplates[element]);
    });
  }

  /**********
   * GET FIELD OF SELECTED FOLDER
   * ********* */
  getFields(e, status) {
    let data
    if (status == "edit") {
      data = e
    } else {
      data = e.currentTarget.value
    }
    let arrIdx = this.arrTemplates.findIndex(element => data === element["id"]);
    if (arrIdx != -1) {
      this.arrTemplateFields = this.arrTemplates[arrIdx]["formLayout"][0][0]["fields"];
    }
  }

  /****
   * Close Rule
   * **** */
  closeRulePage() {
    let discardRule = true;
    let sendData = { status: "discard", resData: discardRule }
    this.clearRulePageComponent.emit(sendData)
  }


  /******************
 * Scheduler Popup
 *********************** */
  openScheduler(e) {
    var data = { "RuleID": this.ruleID };
    var objData = Object.assign({}, this.configApiService.driveApi.pullmailschedule.params, data, { "client": this.configureService.getStudio() })
    this.configApiService.pullRequest(objData, this.getSchedulerData)

  }
  getSchedulerData = ((respdata) => {
    let _data = Object.assign({}, { 'RuleID': this.ruleID }, respdata[0]);
    var SchedulerPage;

    if (Object.keys(this.objRunScheduler).length > 0) {
      if (!this.schedulerModalPopupOpen) {
        this.schedulerModalPopupOpen = true;
        SchedulerPage = this.modalCtrl.create(SchedulerMailTimePopupComponent, { data: this.objRunScheduler }, { cssClass: 'schedulerTimeSetup', enableBackdropDismiss: false });
      }
    } else {
      if (!this.schedulerModalPopupOpen) {
        this.schedulerModalPopupOpen = true;
        SchedulerPage = this.modalCtrl.create(SchedulerMailTimePopupComponent, { data: _data }, { cssClass: 'schedulerTimeSetup', enableBackdropDismiss: false });
      }
    }
    SchedulerPage.present();
    SchedulerPage.onDidDismiss(data => {
      this.schedulerModalPopupOpen = false;

      if (data && Object.keys(data).length > 0) {
        this.objRunScheduler = data;
        if (data.Event) {
          if (data.Event == "Hour") {
            this.ruleRunSchedule.Run_Rule = "Run Every at " + data.Range + " " + data.Event + '.';
          } else if (data.Event == "Day") {
            this.ruleRunSchedule.Run_Rule = "Run Every " + data.Event + " at " + data.Range + " on Time " + data.Time + '.';
          } else if (data.Event == "Month") {
            this.ruleRunSchedule.Run_Rule = "Run Every  " + data.Event + " at " + data.Range + " on " + data.Schedule + 'th ' + data.Time + '.';
          }else if (data.Event == "Onetime") {
            this.ruleRunSchedule.Run_Rule = "Run at " + data.Date + " " + data.Time + '.';
          } 
        }
      }


    });
  })

  onSelectDate(e, index) {
    this.getClickPosition(e, index);
  }

  getClickPosition(e, index) {
    if (jQuery(e.currentTarget).find('.wc-date-popover').css('position') != 'fixed') {
      jQuery(e.currentTarget).find('.wc-date-popover').css('position', 'fixed');
      jQuery(e.currentTarget).find('.wc-date-popover').css('opacity', '0');
    }
    var firsttop = jQuery(e.currentTarget).find('div.wc-date-container').offset().top;
    var secondtop = jQuery(e.currentTarget).find('.wc-date-popover').offset().top;
    var firstleft = jQuery(e.currentTarget).find('div.wc-date-container').offset().left; 	//first element distance from top
    var secondleft = jQuery(e.currentTarget).find('.wc-date-popover').offset().left;
    if (secondleft > 0 && secondtop > 0) {
      var leftDistance = parseInt(firstleft) - parseInt(secondleft);       //second element distance from top
      var topdistance = parseInt(firsttop) - parseInt(secondtop) + 55;
      if (leftDistance > 0 && topdistance > 0) {
        jQuery(e.currentTarget).find('.wc-date-popover').css('top', topdistance + 'px');
        jQuery(e.currentTarget).find('.wc-date-popover').css('left', leftDistance + 'px');
      } else {
        return;
      }
    }
    else {
      return;
    }
    setTimeout(() => {
      if (jQuery('#conditionValue' + index).find('.wc-date-popover').css('opacity') == '0' && jQuery('#conditionValue' + index).find('.wc-date-popover').css('display') == "block") {
        jQuery('#conditionValue' + index).find('.wc-date-popover').css('opacity', '1');
      }
      if (jQuery('#conditionValue' + index).find('.wc-date-popover').css('visibility') == 'hidden' && jQuery('#conditionValue' + index).find('.wc-date-popover').css('display') == "block") {
        jQuery('#conditionValue' + index).find('.wc-date-popover').css('visibility', 'visible');
      }
    }, 1000);
  }
}


// WEBPACK FOOTER //
// ./src/components/rule-engine/rule-engine.ts